import { useAction } from '../../Contexts/CharacterActions.js';
import { useCharacter } from '../../Contexts/CharacterInfo.js';
import { healthName } from '../../Contexts/ConstantsCollection.js';
import TraitSelector from '../../TraitSelector.jsx';

const TraitSelectorButton = ({ Name, Attribute, Traits, onHealRepair }) => {
  const { triggerRollDiceTrait } = useAction();
  const {
    character,
    updateCurrentHealth,
    updateSelectedHealTrait,
    updateCurrentResilience,
    updateSelectedRepairTrait,
    addToUsedTraits,
    saveCharacter,
  } = useCharacter();
  const isHealth = Attribute.name === healthName;

  const healRepair = () => {
    const curr = isHealth
      ? character.currentHealth
      : character.currentResilience;
    const total = isHealth ? character.totalHealth : character.totalResilience;
    var name = isHealth
      ? character.selectedHealTrait?.name
      : character.selectedRepairTrait?.name;
    var roll = triggerRollDiceTrait(name);
    var val = isHealth ? roll * 5 : roll;
    var newVal = Math.min(total, val + curr);
    isHealth ? updateCurrentHealth(newVal) : updateCurrentResilience(newVal);
    addToUsedTraits(name);
    isHealth
      ? updateSelectedHealTrait({ name, disabled: true })
      : updateSelectedRepairTrait({ name, disabled: true });
    if (character.previousSave) saveCharacter();
    onHealRepair(val);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <TraitSelector
        SelectedTrait={
          isHealth ? character.selectedHealTrait : character.selectedRepairTrait
        }
        Traits={Traits}
        ignoreUsedTraits={false}
        setStyle={'compact'}
        baseColor={Attribute.baseColor}
        onSelectionChanged={
          isHealth ? updateSelectedHealTrait : updateSelectedRepairTrait
        }
      />
      <button
        className="hover-button"
        onClick={() => {
          healRepair();
        }}
        disabled={
          character.isDead || isHealth
            ? character.selectedHealTrait.disabled
            : character.selectedRepairTrait.disabled
        }
        style={{
          '--custom-bg': `${Attribute.baseColor}`,
          '--custom-hover': `${Attribute.highlightColor}`,
          '--custom-active': `${Attribute.selectColor}`,
          position: 'relative',
          top: '0px',
          height: '30px',
          width: '60%',
          zIndex: '1',
          border: '3px solid black',
          borderTop: '1px solid black',
          borderRadius: '0px 3px 8px 0px',
        }}
      >
        {Name}
      </button>
    </div>
  );
};

export default TraitSelectorButton;
